import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from 'react-toastify';
// Utils
import Yup from "../../../utils/yup";
// Store and Services
import { saveAgent } from "../../../services/agentService";

function AddAgent() {
    const navigate = useNavigate(); // Hook for navigation
    
    // Validation schema for the form
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Invalid email format"),
        website: Yup.string()
            .required("Website is required")
            .domain(),
        username: Yup.string()
            .min(3, "Username must be at least 3 characters")
            .required("Username is required"),
        password: Yup.string()
            .min(3, "Password must be at least 3 characters")
            .required("Password is required"),
    });

    // Initial values for the form
    const initialValues = {
        name: "",
        email: "",
        website: "",
        username: "",
        password: "",
    };

    // Form submission handler
    const onSubmit = async (values, { setSubmitting, resetForm }) => {
        // console.log('form: ', values);
        
        await saveAgent(values).then((res) => {
            if (res.data.status === "success") {
                toast.success(res.data.message);
                // Redirect after submission
                navigate("/admin/agents"); 
            }
            }).catch((error) => {
            if (error.response && error.response.status === 422) {
                // Validation errors
                const validationErrors = error.response.data.errors;
                for (const [field, messages] of Object.entries(validationErrors)) {
                // Show error messages for each field
                messages.forEach(message => toast.error(`${message}`));
                }
            } else {
                // Other errors
                toast.error('An error occurred. Please try again.');
            }
        
        });

        setSubmitting(false); // Reset isSubmitting to false after submission
    };
    return (
        <>
        <div className="flex justify-between items-end">
            <h1 className="text-lg font-bold">Add Agent</h1>
        </div>

        <hr className="border-black border-2 mt-2" />

        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            >
            {({ isSubmitting }) => (
                <Form className="p-4 md:p-5">
                <div className="grid gap-4 mb-4 grid-cols-2">
                    {/* Name Field */}
                    <div className="col-span-1">
                    <label htmlFor="name" className="form-label required">Name</label>
                    <Field
                        type="text"
                        name="name"
                        id="name"
                        className="form-control"
                        placeholder="Type name"
                    />
                    <ErrorMessage name="name" component="div" className="form-error" />
                    </div>

                    {/* Email Field */}
                    <div className="col-span-2 sm:col-span-1">
                    <label htmlFor="email" className="form-label">Email</label>
                    <Field
                        type="text"
                        name="email"
                        id="email"
                        className="form-control"
                        placeholder="Enter email"
                    />
                    <ErrorMessage name="email" component="div" className="form-error" />
                    </div>

                </div>
                
                <div className="grid gap-4 mb-4 grid-cols-2">
                    
                    {/* Website Field */}
                    <div className="col-span-2 sm:col-span-1">
                    <label htmlFor="website" className="form-label required">Website</label>
                    <Field
                        type="text"
                        name="website"
                        id="website"
                        className="form-control"
                        placeholder="Enter website"
                    />
                    <ErrorMessage name="website" component="div" className="form-error" />
                    </div>

                </div>

                <div className="grid gap-4 mb-4 grid-cols-2">

                    {/* Username Field */}
                    <div className="col-span-2 sm:col-span-1">
                    <label htmlFor="username" className="form-label required">Username</label>
                    <Field
                        type="text"
                        name="username"
                        id="username"
                        className="form-control"
                        placeholder="Enter username"
                    />
                    <ErrorMessage name="username" component="div" className="form-error" />
                    </div>

                    {/* Password Field */}
                    <div className="col-span-2 sm:col-span-1">
                    <label htmlFor="password" className="form-label required">Password</label>
                    <Field
                        type="text"
                        name="password"
                        id="password"
                        className="form-control"
                        placeholder="Enter password"
                    />
                    <ErrorMessage name="password" component="div" className="form-error" />
                    </div>

                </div>

                {/* Submit Button */}
                <div className="w-full flex justify-end">
                    <button
                    type="submit"
                    className="btn-primary"
                    disabled={isSubmitting}
                    >
                    {isSubmitting ? "Saving..." : "Add Agent"}
                    </button>
                </div>
                </Form>
            )}
            </Formik>
        </>
    );
}

export default AddAgent;
